import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import ChartTypes from "@/components/ChartTypes.tsx";
import BalliTeacherDashboard from "@/views/dashboard/teacher/balli/BalliTeacherDashboard";
import { ACCOUNT_TYPES } from "@/store/UserStore.ts";
import BalliStudentDashboard from "./student/balli/BalliStudentDashboard";
import BalaStudentDashboard from "./student/bala/BalaStudentDashboard";
import BalaTeacherDashboard from "./teacher/bala/SkillsDashboard";
import { updateTeacherScoring } from "@/service/DashboardBackend.ts";
import BalaTeacherDashboardGeneral from "./teacher/bala/general/DashboardGeneral";
import { spawn } from "child_process";
import DashboardGeneral from "./teacher/bala/general/DashboardGeneral";
import SkillsDashboard from "./teacher/bala/SkillsDashboard";
import TestletsDashboard from "./teacher/bala/TestletsDashboard";

@Component
export default class DashboardMain extends Vue {
  private showMenu: any;
  private menuX: any;
  private menuY: any;
  private user!: {
    loggedIn: false;
    data: { email: any; uid: any };
    accountType: ACCOUNT_TYPES.STUDENT | ACCOUNT_TYPES.TEACHER;
  };
  private reportName: any;
  private currentState: any;
  private reports: any;

  private reportToDashboardMap: any = {
    [ACCOUNT_TYPES.TEACHER]: {
      "bala-reading": {
        general: DashboardGeneral,
        skills: SkillsDashboard,
        testlets: TestletsDashboard
      }
    },
    [ACCOUNT_TYPES.STUDENT]: {
      "bala-reading": BalaStudentDashboard
    }
  };

  created() {
    this.showMenu = false;
    this.menuX = 0;
    this.menuY = 0;
    this.reports = {
      [ACCOUNT_TYPES.TEACHER]: {
        "bala-reading": ["general", "skills", "testlets"],
        "bala-writing": [],
        balli: []
      },
      [ACCOUNT_TYPES.STUDENT]: {
        "bala-reading": [],
        "bala-writing": [],
        balli: []
      }
    };
    this.reportName = {
      "bala-reading": "BALA Reading Assessment Results"
    };
    this.user = this.$store.getters.user;
    this.currentState = null;
  }

  private stateLoaded() {
    if (this.currentState != null) return true;

    if (this.$store.getters.user.accountType != null) {
      let reports = this.reports[this.user.accountType];
      let reportsList = Object.keys(reports);
      let subreportList = reports[reportsList[0]];
      let subreport = subreportList.length > 0 ? 0 : null;
      this.currentState = {
        userType: this.user.accountType,
        reports: reports,
        timepoint: 1,
        reportList: reportsList,
        report: 0,
        subreportList: subreportList,
        subreport: subreport
      };
      return true;
    }
    return false;
  }

  toolbar() {
    return (
      <v-container style={{ paddingBottom: "0" }}>
        <v-toolbar class="elevation-1">
          <v-app-bar-nav-icon
            onClick={(e: any) => {
              e.preventDefault();
              this.menuX = e.clientX;
              this.menuY = e.clientY;
              this.showMenu = false;
              this.$forceUpdate();
              this.$nextTick(() => {
                this.showMenu = true;
                this.$forceUpdate();
              });
            }}
          ></v-app-bar-nav-icon>

          <v-toolbar-title>
            {
              this.reportName[
                this.currentState.reportList[this.currentState.report]
              ]
            }
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon>mdi-heart</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
          {this.currentState.subreport != null ? (
            <span slot="extension">
              {this.currentState.subreportList.map(
                (report: string, i: number) => (
                  <v-btn
                    tile
                    bottom
                    depressed
                    color={this.currentState.subreport == i ? "#3F51B5" : ""}
                    light
                    text
                    onClick={() => {
                      this.currentState.subreport = i;
                      this.$forceUpdate();
                    }}
                  >
                    {report}
                  </v-btn>
                )
              )}
            </span>
          ) : (
            ""
          )}
        </v-toolbar>
      </v-container>
    );
  }

  dashboardSelector() {
    let c = this.currentState;
    let report = c.reportList[c.report];
    let subReport = null;
    if (c.reports[report].length > 0) {
      subReport = c.reports[report][c.subreport];
    }
    if (c.userType == ACCOUNT_TYPES.TEACHER) updateTeacherScoring();

    let dashboard = this.reportToDashboardMap[c.userType][report];
    if (subReport != null) dashboard = dashboard[subReport];

    return this.$createElement(dashboard);
  }

  private dropdownMenu() {
    return (
      <v-menu
        v-model={this.showMenu}
        offset-y
        absolute
        position-x={this.menuX}
        position-y={this.menuY}
      >
        <v-list>
          <v-list-item-group v-model={this.currentState.report}>
            {this.currentState.reportList.map((title: string) => (
              <v-list-item
                onClick={() => {
                  this.$forceUpdate();
                }}
              >
                <v-list-item-title>{title}</v-list-item-title>
              </v-list-item>
            ))}
          </v-list-item-group>
        </v-list>
      </v-menu>
    );
  }

  render(h: CreateElement) {
    return (
      this.stateLoaded() && (
        <v-container>
          {this.toolbar()}
          {this.dropdownMenu()}
          {this.dashboardSelector()}
        </v-container>
        /* </v-container> */
      )
    );
  }
}

const component = DashboardMain;
